// extracted by mini-css-extract-plugin
module.exports = {"menuToggle":"BNV0r","toggleOpen":"_2qdUI","buttonContainer":"_3SNA4","icon":"_1BxvD","menu6":"_2CwYF"};